import { Component, Inject, ViewChild } from '@angular/core';
import { NgModel } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogBase } from 't4core';
import { LocationUserInfo } from 't4core';

@Component({
    selector: 'EditLocationUser',
    templateUrl: 'EditLocationUser.html',
})
export class EditLocationUserDialog extends DialogBase {
    public user: LocationUserInfo = new LocationUserInfo();

    @ViewChild("txtFirstname", {static: false}) public txtFirstname: NgModel;
    @ViewChild("txtLastname", {static: false}) public txtLastname: NgModel;
    @ViewChild("txtPinCode", {static: false}) public txtPinCode: NgModel;
    @ViewChild("txtEmail", {static: false}) public txtEmail: NgModel;

    constructor(
        public dialogRef: MatDialogRef<EditLocationUserDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        super("EditLocationUserDialog");

        if (data && data.user) this.user = data.user;
    }

    public async save() {
        this.txtFirstname.control.markAsTouched();
        this.txtLastname.control.markAsTouched();
        this.txtPinCode.control.markAsTouched();
        this.txtEmail.control.markAsTouched();

        if (!this.txtFirstname.valid || !this.txtLastname.valid || !this.txtPinCode.valid || !this.txtEmail.valid) return;

        this.dialogRef.close(this.user);
    }
}
